var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66634 0.666626C8.88735 0.666626 9.09932 0.754423 9.2556 0.910704L13.4223 5.07737C13.5785 5.23365 13.6663 5.44561 13.6663 5.66663V14.8333C13.6663 16.214 12.5471 17.3333 11.1663 17.3333H2.83301C1.4523 17.3333 0.333008 16.214 0.333008 14.8333V3.16663C0.333008 1.78591 1.4523 0.666626 2.83301 0.666626H8.66634ZM6.99884 2.33329H2.83301C2.37277 2.33329 1.99967 2.70639 1.99967 3.16663V14.8333C1.99967 15.2935 2.37277 15.6666 2.83301 15.6666H11.1663C11.6266 15.6666 11.9997 15.2935 11.9997 14.8333V7.33329H7.83301C7.40564 7.33329 7.05342 7.01159 7.00528 6.59714L6.99967 6.49996L6.99884 2.33329ZM11.6547 5.66663L8.66551 2.67829L8.66634 5.66663H11.6547Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManual);
export default __webpack_public_path__ + "static/media/manual.b4706cc5.svg";
export { ForwardRef as ReactComponent };